import { createAction, props } from '@ngrx/store';

import { IGridData } from './grid.state';

export const setSkipRows = createAction(
  "[Grid] Set SkipRows",
  props<{ skipRows: number; gridName: string }>()
);

export const setGridState = createAction(
  "[Grid] Set GridState",
  props<{ gridState: IGridData; gridName: string }>()
);

export const setSearchCriteria = createAction(
  "[Grid] Set SearchCriteria",
  props<{ searchCriteria: any; gridName: string }>()
);

export const setIdentifier = createAction(
  "[Grid] Set Identifier",
  props<{ identifier: string | number; gridName: string }>()
);

export const setPageNumber = createAction(
  "[Grid] Set PageNumber",
  props<{ pageNumber: number; gridName: string }>()
);

export const setRowsPerPage = createAction(
  "[Grid] Set RowsPerPage",
  props<{ rowsPerPage: number; gridName: string }>()
);

export const resetIdentifier = createAction(
  "[Grid] Reset Identifier",
  props<{ gridName: string }>()
);
